export default __webpack_public_path__ + "static/media/background.72c48810.png";